import React, { useState } from "react";
import { useAuth } from "../../store/AuthContext";
import { T } from "../shared/UI";

export default function LoginPage() {
  const { login, loading, error } = useAuth();
  const [mobile,   setMobile]   = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [touched,  setTouched]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (!mobile || !password) return;
    try { await login({ mobile, password }); }
    catch { /* shown via error state */ }
  };

  return (
    <div style={styles.bg}>
      <div style={styles.glow1} />
      <div style={styles.glow2} />
      <div style={styles.glow3} />
      <div style={styles.grid} />

      <div style={styles.card}>
        {/* Logo */}
        <div style={styles.logoRow}>
          <div style={styles.logoMark}>SLV</div>
          <div>
            <div style={styles.logoText}>SLV ASSOCIATES</div>
            <div style={styles.logoSub}>Admin Console</div>
          </div>
        </div>
        <div style={styles.divider} />

        <h2 style={styles.heading}>Sign In</h2>
        <p style={styles.sub}>Enter your admin credentials to continue</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          {/* Mobile */}
          <div style={styles.fieldWrap}>
            <label style={styles.label}>MOBILE NUMBER</label>
            <div style={styles.inputWrap}>
              <span style={styles.inputIcon}>📱</span>
              <input
                style={{ ...styles.input, borderColor: touched && !mobile ? T.sos : T.border2 }}
                type="tel"
                placeholder="9876543210"
                value={mobile}
                onChange={e => setMobile(e.target.value.replace(/\D/g,"").slice(0,10))}
                maxLength={10}
                autoFocus
              />
            </div>
            {touched && !mobile && <div style={styles.fieldErr}>Mobile number required</div>}
          </div>

          {/* Password */}
          <div style={styles.fieldWrap}>
            <label style={styles.label}>PASSWORD</label>
            <div style={styles.inputWrap}>
              <span style={styles.inputIcon}>🔒</span>
              <input
                style={{ ...styles.input, borderColor: touched && !password ? T.sos : T.border2, paddingRight: 44 }}
                type={showPass ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <button type="button" style={styles.eyeBtn} onClick={() => setShowPass(v=>!v)}>
                {showPass ? "🙈" : "👁"}
              </button>
            </div>
            {touched && !password && <div style={styles.fieldErr}>Password required</div>}
          </div>

          {/* API error */}
          {error && (
            <div style={styles.apiErr}>
              <span style={{fontSize:16}}>⚠</span> {error}
            </div>
          )}

          <button type="submit" style={{ ...styles.submitBtn, opacity: loading ? 0.75 : 1 }} disabled={loading}>
            {loading
              ? <span style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                  <span style={styles.spinner} /> Signing in...
                </span>
              : "Sign In →"
            }
          </button>
        </form>

        {/* Status pills */}
        <div style={styles.footer}>
          <div style={styles.footerRow}>
            <div style={{...styles.pill, background:"rgba(106,247,196,0.08)", borderColor:"rgba(106,247,196,0.2)", color:T.acc3}}>
              <div style={{width:6,height:6,borderRadius:"50%",background:T.acc3,animation:"pulse 1.5s infinite"}} />
              LIVE TRACKING
            </div>
            <div style={{...styles.pill, background:"rgba(124,106,247,0.08)", borderColor:"rgba(124,106,247,0.2)", color:T.acc}}>
              🔒 SECURE
            </div>
            <div style={{...styles.pill, background:"rgba(255,68,102,0.08)", borderColor:"rgba(255,68,102,0.2)", color:T.sos}}>
              🚨 SOS ALERTS
            </div>
          </div>
          <div style={styles.footerNote}>
            API · <span style={{color:T.acc3, fontFamily:T.fontMono, fontSize:10}}>api.slvassociates.org</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  bg: { minHeight:"100vh", width:"100%", background:T.bg, display:"flex", alignItems:"center", justifyContent:"center", position:"relative", overflow:"hidden" },
  glow1: { position:"absolute", width:500, height:500, borderRadius:"50%", background:"radial-gradient(circle, rgba(124,106,247,0.13) 0%, transparent 70%)", top:"-15%", left:"-15%", pointerEvents:"none" },
  glow2: { position:"absolute", width:400, height:400, borderRadius:"50%", background:"radial-gradient(circle, rgba(106,247,196,0.07) 0%, transparent 70%)", bottom:"-10%", right:"5%", pointerEvents:"none" },
  glow3: { position:"absolute", width:300, height:300, borderRadius:"50%", background:"radial-gradient(circle, rgba(255,68,102,0.06) 0%, transparent 70%)", top:"40%", right:"10%", pointerEvents:"none" },
  grid: { position:"absolute", inset:0, backgroundImage:"linear-gradient(rgba(22,32,48,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(22,32,48,0.4) 1px, transparent 1px)", backgroundSize:"50px 50px", pointerEvents:"none" },
  card: { position:"relative", zIndex:1, width:420, maxWidth:"calc(100vw - 32px)", background:T.s1, border:`1px solid ${T.border2}`, borderRadius:18, padding:"32px 36px", boxShadow:"0 24px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(124,106,247,0.08)" },
  logoRow: { display:"flex", alignItems:"center", gap:12, marginBottom:24 },
  logoMark: { width:44, height:44, borderRadius:11, background:T.acc, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:T.fontMono, fontSize:16, fontWeight:700, color:"#fff", boxShadow:"0 0 24px rgba(124,106,247,0.5)", flexShrink:0 },
  logoText: { fontSize:14, fontWeight:800, color:T.text, letterSpacing:"2px" },
  logoSub:  { fontSize:11, color:T.muted, marginTop:2 },
  divider:  { height:1, background:T.border, marginBottom:24 },
  heading:  { fontSize:22, fontWeight:800, color:T.text, marginBottom:6 },
  sub:      { fontSize:13, color:T.muted, marginBottom:28 },
  form:     { display:"flex", flexDirection:"column", gap:18 },
  fieldWrap:{ display:"flex", flexDirection:"column", gap:6 },
  label:    { fontFamily:T.fontMono, fontSize:10, letterSpacing:"1.5px", color:T.muted, textTransform:"uppercase" },
  inputWrap:{ position:"relative" },
  inputIcon:{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", fontSize:15, pointerEvents:"none" },
  input:    { width:"100%", boxSizing:"border-box", background:T.s2, border:`1px solid`, borderRadius:10, padding:"12px 14px 12px 40px", color:T.text, fontFamily:T.fontSans, fontSize:14, outline:"none", transition:"border-color 0.2s" },
  eyeBtn:   { position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:15 },
  fieldErr: { fontSize:11, color:T.sos },
  apiErr:   { display:"flex", alignItems:"center", gap:8, background:"rgba(255,68,102,0.1)", border:"1px solid rgba(255,68,102,0.35)", borderRadius:8, padding:"10px 14px", fontSize:13, color:T.sos },
  submitBtn:{ width:"100%", padding:"13px", background:T.acc, border:"none", borderRadius:10, color:"#fff", fontSize:15, fontWeight:700, fontFamily:T.fontSans, cursor:"pointer", transition:"all 0.2s", boxShadow:"0 4px 20px rgba(124,106,247,0.4)", letterSpacing:"0.3px" },
  spinner:  { width:16, height:16, borderRadius:"50%", border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"#fff", animation:"spin 0.8s linear infinite", display:"inline-block" },
  footer:   { marginTop:24 },
  footerRow:{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:10 },
  pill:     { display:"flex", alignItems:"center", gap:5, border:"1px solid", borderRadius:20, padding:"4px 10px", fontSize:10, fontFamily:T.fontMono, letterSpacing:"0.5px" },
  footerNote:{ fontSize:11, color:T.muted2, textAlign:"center" },
};
